import { render, staticRenderFns } from "./SceneElements.vue?vue&type=template&id=56d97661&scoped=true"
import script from "./SceneElements.vue?vue&type=script&lang=js"
export * from "./SceneElements.vue?vue&type=script&lang=js"
import style0 from "./SceneElements.vue?vue&type=style&index=0&id=56d97661&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d97661",
  null
  
)

export default component.exports